export default __webpack_public_path__ + "static/media/changerightleft.8ccd0acc.mp3";